<div class="items">
  @for (item of user_payment_intent.items; track $index) {
  <app-checkout-list-item [item]="item"></app-checkout-list-item>
  }
</div>
<mat-divider></mat-divider>
<div class="line">
  <span>Subtotal</span>
  <app-price [price]="user_payment_intent.subtotal"></app-price>
</div>
<div class="line">
  <span>Shipping Fee</span>
  @if (user_payment_intent.shipping_fee > 0) {
  <app-price [price]="user_payment_intent.shipping_fee"></app-price>
  }@else{
  <span>Free</span>
  }
</div>
<div class="line total">
  <span>Total</span>
  <app-price [price]="user_payment_intent.total"></app-price>
</div>
